export class producto {
  codigo: number;
  empresa_rut: number;
  sku: string;
  descripcion: string;
  descripcion_ext: string;
  es_exento: boolean;
  codigo_barras: string;
  fecha_registro: Date;
  activo: boolean;
  favorito: boolean;
  familia_codigo: number;
  tipo_producto_codigo: number;
  unidad_medida_codigo: number;
  afecto_reglas_comerciales: boolean;
  no_aplica_descuento: boolean;
  fecha_caducidad_combo: Date;
  fecha_inicio_combo: Date;
  rubro_codigo: number;
  unidad_negocio_codigo: number;
  seguimiento: boolean;
}
